module.exports = __webpack_public_path__ + "static/img/charm_level_81.551e244.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_81.png
// module id = 5Vf9
// module chunks = 0